import { forwardRef } from 'react';

import { SolidArrowIcon } from './SolidArrowIcon';
import { ArrowIcon } from './ArrowIcon';

import type { DetailedHTMLProps, HTMLAttributes } from 'react';

export type TooltipArrowProps = {
  variant: 'primary' | 'outline';
} & Omit<DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>, 'css'>;

export const TooltipArrow = forwardRef<HTMLDivElement, TooltipArrowProps>(function TooltipArrow(
  { variant, ...props },
  ref,
) {
  return (
    <div ref={ref} {...props}>
      {variant === 'primary' ? <SolidArrowIcon /> : <ArrowIcon />}
    </div>
  );
});
